import { IUser } from 'api/users/models'
import { IWealthicaSubscriptionDto } from './dtos'

export const mapWealthicPlanToBlockSentry = (plan?: IWealthicaSubscriptionDto['plan']): IUser['currentPlan'] => {
	switch (plan) {
		case 'blocksentry_blocksentry_expert':
			return 'EXPERT'
		case 'blocksentry_blocksentry_platinum':
			return 'PLATINUM'
		case 'blocksentry_blocksentry_pro':
			return 'PRO'
		case 'blocksentry_blocksentry_free':
		default:
			return 'FREE'
	}
}
